var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreenContent21(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "137.621px",
    height: "89.507px",
    viewBox: "0 0 137.621 89.507",
    enableBackground: "new 0 0 137.621 89.507",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFD3AE",
    stroke: "#FFD3AE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "6.817,2  135.742,80.233 132.734,87.625 2.002,15.638  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E5AF88",
    stroke: "#E5AF88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 10.584,8.875 24.65,17.281 23.109,22.189 8.799,14.157  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E5AF88",
    stroke: "#E5AF88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 114.082,70.483 112.406,73.808 127.709,82.437 129.031,79.305  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenContent21);
export default __webpack_public_path__ + "static/media/screen_content2_1.42d129f9b7e745666c970af34dfb3078.svg";
export { ForwardRef as ReactComponent };